import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedBrandPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBrandStateByPath } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getIsBrandPage } from "@store/Pages/ProductList/ProductListSelectors";
import { getCatalogPage } from "@store/Store/Data/Categories/CategoriesSelectors";

export const getBrand = (state: ApplicationState) => {
    const currentPage = getCurrentPage(state);
    const currentPath = getLocation(state).pathname;
    if (currentPage.type === "BrandDetailsPage") {
        const brandPath = getSelectedBrandPath(state) || currentPath;
        const brandState = getBrandStateByPath(state, brandPath);
        const brand = brandState.value;
        return brand;
    }
};

export const getBrandId = (state: ApplicationState) => {
    const brand = getBrand(state);
    if (brand) {
        return brand.id;
    }
    const catalogPage = getCatalogPage(state);
    const isBrandPage = getIsBrandPage(state);
    if (catalogPage && isBrandPage) {
        return catalogPage.brandId;
    }
};
